import { FULL_EMAIL_REGEX } from './emailRegex'

export const getCleanEmail = (value: string): string => {
  const emailRegexp = new RegExp(FULL_EMAIL_REGEX)
  const match = emailRegexp.exec(value)

  return match && match.length > 0 ? match[0] : value
}
